import React, { useContext, useEffect, useMemo, useState } from 'react';
import { CssBaseline, Grid, Snackbar, Tooltip, IconButton, Paper, Button, useMediaQuery, useTheme, Badge } from '@mui/material';
import { FormattedMessage, useIntl } from 'react-intl';
import _ from "lodash/fp";
import useStyles from '../common/CommonStyle/CommonStyle';
import { GridToolbarColumnsButton, GridToolbarDensitySelector, LicenseInfo, DataGridPro, getGridDateOperators } from '@mui/x-data-grid-pro';
import { ModuleAccessPermissionKey } from '../../Constants/ModuleAccessKey';
import GridTextLocalization from '../common/GridTextLocalization/GridTextLocalization';
import { GlobalEdiApiConstants } from '../../Constants/GlobalEdiApiConstants';
import { LoggedInUserDetails } from '../common/LoggedInUserDetails/LoggedInUserDetails';
import { SupportedLanguageDetails } from '../common/SupportedLanguageDetails/SupportedLanguageDetails';
import IconSettings from '@mui/icons-material/Settings';
import IconSupplier from '@mui/icons-material/LocalShipping';
import IconEmailMessageConfig from '@mui/icons-material/ContactMail';
import { CommonService } from '../../services';
import CreateIcon from '@mui/icons-material/Add';
import ViewIcon from '@mui/icons-material/Visibility';
import EditIcon from '@mui/icons-material/EditOutlined';
import { CustomFilters } from '../common/CustomFilters/CustomFilters';
import RefreshIcon from '@mui/icons-material/Refresh';
import { Alert } from '@mui/lab';
import CommonGridPagination from '../common/CommonGridPagination/CommonGridPagination';
import IconUserManagement from '@mui/icons-material/AccountCircle';
import EmailMessageConfigDiaglog from './EmailMessageConfigDialog';
import CustomFilterComponent, { GetFilterableColumns } from '../common/CustomFilterComponent';
import { FilterList } from '@mui/icons-material';
import DeleteIcon from '@mui/icons-material/DeleteOutlineOutlined';
import ConfirmationDialog from '.././common/ConfirmationDialog';

const columnFieldsName = {
    contactName: 'contactName',
    contactSalutation: 'contactSalutation',
    project: 'project',
    countryCode: 'countryCode',
    contactNo: 'contactNo',
    emailTo: 'emailTo',
    emailCc: 'emailCc',
    emailBcc: 'emailBcc',
    bpType: 'bpType',
    bpCode: 'bpCode',
    bpName: 'bpName',
    status: 'status',
     pemailTo: 'pemailTo',
    pemailCc: 'pemailCc',
     pemailBcc: 'pemailBcc',
    processSpecific:'processSpecific',
    process : 'process',
    createdTime: 'createdTime',
    createdBy: 'createdBy',
    updatedTime: 'updatedTime',
    updatedBy: 'updatedBy',
    validFrom: 'validFrom',
    validTo: 'validTo',
    entityContact: 'user.userName'
}

const BpEmailCommConfig = (props) => {
    const classes = useStyles();
    const intl = useIntl();
    const theme = useTheme();
    const { mode, componentListForBp, supplierObjectToBeEditedOrView, customerObjectToBeEditedOrView } = props;
    const X_GRID_LICENSE_KEY = `${process.env.REACT_APP_X_GRID_LICENSE_KEY}`.toString();
    LicenseInfo.setLicenseKey(
        X_GRID_LICENSE_KEY,
    );
    const moduleAccessKeyPermission = ModuleAccessPermissionKey();
    const { loggedInUserInfo } = useContext(LoggedInUserDetails);
    const emailMessageConfigModuleAccess = loggedInUserInfo.roleModuleAccess[moduleAccessKeyPermission.emailMessageConfig];
    const selectedLanguage = useContext(SupportedLanguageDetails);
    const localtext = GridTextLocalization();
    const apiUrlAndParamBodyConstants = GlobalEdiApiConstants();
    const mobileScreen = useMediaQuery(theme.breakpoints.down('md'));

    const pageLabelsConstantsAndMessages = {
        label: {
            createButton: 'Create',
            editButton: 'Edit',
            refreshButton: 'Refresh',
            applyFilterButton: 'Apply Filter',
            columns: 'Columns to View',
            filters: 'Filter the columns',
            Density: 'Density',
        },
        alignment: {
            alignLeft: 'left',
            alignRight: 'right',
            alignCenter: 'center',
        },
        name: {
            name: 'name'
        }
    };

    const componentListForSupplier = [
        {
            path: undefined,
            name: <FormattedMessage id="common.menu.breadcrumb.settings" defaultMessage="Settings" />,
            iconName: IconSettings,
        },
        {
            path: '/suppliers',
            name: <FormattedMessage id="common.menu.module.breadcrumb.supplier" defaultMessage="Suppliers" />,
            iconName: IconSupplier,
        },
        {
            path: undefined,
            name: <FormattedMessage id="common.menu.breadcrumb.emailmessageconfig" />,
            iconName: IconEmailMessageConfig,
        }
    ];

    const componentListForCustomer = [
        {
            path: undefined,
            name: <FormattedMessage id="common.menu.breadcrumb.settings" defaultMessage="Settings" />,
            iconName: IconSettings,
        },
        {
            path: '/customer',
            name: <FormattedMessage id="common.menu.breadcrumb.customer" defaultMessage="Customer" />,
            iconName: IconUserManagement,
        },
        {
            path: undefined,
            name: <FormattedMessage id="common.menu.breadcrumb.emailmessageconfig" />,
            iconName: IconEmailMessageConfig,
        }
    ];

    const [alertBoxState, setAlertBoxState] = React.useState({
        openAlert: false,
        vertical: 'top',
        horizontal: 'center',
        message: '',
        severity: ''
    });
    const handleCloseAlert = () => {
        setAlertBoxState({ ...alertBoxState, openAlert: false });
    };
    const { vertical, horizontal, openAlert, message, severity } = alertBoxState;

    const bpCode = supplierObjectToBeEditedOrView === undefined ? customerObjectToBeEditedOrView.bpCode : supplierObjectToBeEditedOrView.bpCode;

    const bpType = supplierObjectToBeEditedOrView === undefined ? 'CUSTOMER' : 'SUPPLIER';
// Adding EntityCode to Param body
let entityCode = '';
if (bpType === "SUPPLIER") {
    entityCode = supplierObjectToBeEditedOrView?.entity === undefined
        ? supplierObjectToBeEditedOrView?.erpEntityCode || ''
        : supplierObjectToBeEditedOrView?.entity?.erpEntityCode || '';
} else if (bpType === "CUSTOMER") {
    entityCode = customerObjectToBeEditedOrView?.entity === undefined
        ? customerObjectToBeEditedOrView?.erpEntityCode || ''
        : customerObjectToBeEditedOrView?.entity?.erpEntityCode || '';
}
const [paramBody, setParamBody] = useState(() => {
  const body = {
    bpCode: bpCode || '',
    bpType: bpType || '',
  entityCode: entityCode || ''
    
  };
  
  console.log('Initial paramBody:', body);
  
  return {
    ...apiUrlAndParamBodyConstants.paramBodyForGetListApis.bpEmailMessageConfigs,
    body
  };
});
    const [tableLoadingStatus, setTableLoadingStatus] = useState(false);
    const [totalRowCount, setTotalRowCount] = useState(0);
    const [refreshTable, setRefreshTable] = useState(false);
    const [OpenEmailMessageConfigDialog, setOpenEmailMessageConfigDialog] = useState(false);
    const [modeForEmailConfig, setModeForEmailConfig] = useState('');
    const [emailMessageConfigObjectToBeEditedOrView, setEmailMessageConfigObjectToBeEditedOrView] = useState({});

    const [openFilterPanel, setFilterPanel] = useState(false);
    const handleClose = () => {
        setFilterPanel(false);
    }
    const [filterCount, setFilterCount] = React.useState(0);
    const defaulSelectedFilters = [];
    const [selectedFilters, setSelectedFilters] = useState([]);

    const [openConfirmationDialog, setOpenConfirmationDialog] = useState(false);

    const [primaryKeyOfSelectedRow, setPrimaryKeyOfSelectedRow] = useState(0);
    const [confirmationMessage, setConfirmationMessage] = useState('');

    const closeEmailMessageConfigDialog = (confirmed) => {
        if (confirmed) {
            setRefreshTable(!refreshTable);
        }
        setEmailMessageConfigObjectToBeEditedOrView({});
        setOpenEmailMessageConfigDialog(false);
    }
    const commonBreadCrumbToBeUsedForDialog = componentListForBp[1].path === '/suppliers' ? componentListForSupplier : componentListForCustomer;

    const columnsForEmailMessageConfig =
        [
            {
                field: 'action',
                headerName: intl.formatMessage({ id: "columnname.action.label" }),
                width: mode === 'read' ? 100 : 130,
                sortable: false,
                hide: false,
                headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
                align: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
                filterable: false,
                renderHeader: CommonService.customRenderHeaderColumns,
                renderCell: (cellParams) => (
                    <div>
                        {(emailMessageConfigModuleAccess !== undefined ? emailMessageConfigModuleAccess.editFlag : false) && (mode !== 'read') && (
                            <Tooltip title={<FormattedMessage id="common.tooltip.breadcrumb.edit" defaultMessage="Edit" />}
                                placement='bottom' className={classes.actionButton} onClick={(() => {
                                    setModeForEmailConfig('edit');
                                    setEmailMessageConfigObjectToBeEditedOrView(cellParams.row);
                                    setOpenEmailMessageConfigDialog(true)
                                })}>
                                <span>
                                    <IconButton className={classes.customeToolbar} size="large">
                                        <EditIcon />
                                    </IconButton>
                                </span>
                            </Tooltip>)}
                        {(emailMessageConfigModuleAccess !== undefined ? emailMessageConfigModuleAccess.readFlag : false) && (
                            <Tooltip title={<FormattedMessage id="common.button.view.breadcrumb.tooltip" defaultMessage={pageLabelsConstantsAndMessages.label.readButton} />}
                                placement='bottom' className={classes.actionButton} onClick={(() => {
                                    setModeForEmailConfig('read')
                                    setEmailMessageConfigObjectToBeEditedOrView(cellParams.row)
                                    setOpenEmailMessageConfigDialog(true)
                                })}>
                                <span>
                                    <IconButton className={classes.customeToolbar} size="large">
                                        <ViewIcon />
                                    </IconButton>
                                </span>
                            </Tooltip>)}
                        {(emailMessageConfigModuleAccess !== undefined ? emailMessageConfigModuleAccess.deleteFlag : false) && (mode !== 'read') &&
                            (<Tooltip title={<FormattedMessage id="common.button.delete.tooltip" defaultMessage="Delete" />}
                                placement='bottom' className={classes.actionButton} onClick={(() => {
                                    handleDelete(cellParams.row.id, cellParams.row.contactName, cellParams.row.project);
                                })}>
                                <span>
                                    <IconButton color='secondary' size="large">
                                        <DeleteIcon />
                                    </IconButton>
                                </span>
                            </Tooltip>)}
                    </div>
                )
            },
            {
                field: columnFieldsName.status,
                headerName: intl.formatMessage({ id: "switch.projeectall.label" }),
                headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
                align: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
                width: 140,
                sortable: true,
                type: 'string',
                hide: false,
                filterable: false,
                renderHeader: CommonService.customRenderHeaderColumns,
                renderCell: CommonService.customRenderYesOrNoColumn
            },
            {
                field: columnFieldsName.project,
                width: 150,
                headerName: intl.formatMessage({ id: "common.textfield.column.project" }),
                headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
                align: `${pageLabelsConstantsAndMessages.alignment.alignLeft}`,
                sortable: true,
                type: 'string',
                filterable: true,
                hide: false,
                renderHeader: CommonService.customRenderHeaderColumns,
            },
            {
                field: columnFieldsName.contactName,
                headerName: intl.formatMessage({ id: "columnname.textfield.attntoname.label" }),
                width: 170,
                headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
                align: `${pageLabelsConstantsAndMessages.alignment.alignLeft}`,
                sortable: true,
                type: 'string',
                hide: false,
                filterable: false,
                renderHeader: CommonService.customRenderHeaderColumns,
            },
            {
                field: columnFieldsName.countryCode,
                headerName: intl.formatMessage({ id: "columnname.textfield.countrycodeph.label" }),
                headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
                align: `${pageLabelsConstantsAndMessages.alignment.alignRight}`,
                width: 110,
                sortable: false,
                type: 'string',
                filterable: false,
                hide: false,
                renderHeader: CommonService.customRenderHeaderColumns,
            },
            {
                field: columnFieldsName.contactNo,
                headerName: intl.formatMessage({ id: "columnname.textfield.attntocontactno.label" }),
                headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
                align: `${pageLabelsConstantsAndMessages.alignment.alignRight}`,
                width: 210,
                sortable: true,
                filterable: false,
                type: 'string',
                hide: false,
                renderHeader: CommonService.customRenderHeaderColumns
            },
            {
                field: columnFieldsName.emailTo,
                headerName: intl.formatMessage({ id: "textfield.bpemailto.label" }),
                headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
                align: `${pageLabelsConstantsAndMessages.alignment.alignLeft}`,
                width: 350,
                sortable: true,
                filterable: false,
                type: 'string',
                hide: true,
                renderHeader: CommonService.customRenderHeaderColumns
            },
            {
                field: columnFieldsName.emailCc,
                headerName: intl.formatMessage({ id: "textfield.bpemailfrom.label" }),
                headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
                align: `${pageLabelsConstantsAndMessages.alignment.alignLeft}`,
                width: 350,
                sortable: true,
                filterable: false,
                type: 'string',
                hide: true,
                renderHeader: CommonService.customRenderHeaderColumns
            },
            {
                field: columnFieldsName.emailBcc,
                headerName: intl.formatMessage({ id: "textfield.bpemailbcc.label" }),
                headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
                align: `${pageLabelsConstantsAndMessages.alignment.alignLeft}`,
                width: 350,
                sortable: true,
                filterable: false,
                type: 'string',
                hide: true,
                renderHeader: CommonService.customRenderHeaderColumns
            },
            {
                field: columnFieldsName.validFrom,
                headerName: intl.formatMessage({ id: "columnname.validfromdate.label" }),
                headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
                align: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
                width: 190,
                sortable: true,
                type: 'date',
                hide: false,
                renderHeader: CommonService.customRenderHeaderColumns,
                renderCell: (cellParams) => (
                    <span>{cellParams.row.validFromDisp}</span>
                )
            },
            {
                field: columnFieldsName.validTo,
                headerName: intl.formatMessage({ id: "columnname.validtodate.label" }),
                headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
                align: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
                width: 190,
                sortable: true,
                filterable: true,
                type: 'date',
                hide: false,
                renderHeader: CommonService.customRenderHeaderColumns,
                renderCell: (cellParams) => (
                    <span>{cellParams.row.validToDisp}</span>
                )
            },
           
            {
                field: columnFieldsName.entityContact,
                headerName: intl.formatMessage({ id: "columnname.entitycontactname.label" }),
                headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
                align: `${pageLabelsConstantsAndMessages.alignment.alignLeft}`,
                width: 205,
                sortable: true,
                filterable: false,
                type: 'date',
                hide: false,
                valueGetter: (params) => `${params.row.user === null ? '' : params.row.user.userName}`,
                renderHeader: CommonService.customRenderHeaderColumns,
            },
             {
                field: columnFieldsName.processSpecific,
                headerName: intl.formatMessage({ id: "switch.processs.label"}),
                headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
                align: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
                width: 140,
                sortable: true,
                type: 'string',
                hide: false,
                filterable: false,
                renderHeader: CommonService.customRenderHeaderColumns,
                renderCell: CommonService.customRenderYesOrNoColumn
            },
             {
                field: columnFieldsName.process,
                headerName: intl.formatMessage({ id: "textfield.process.label"}),
                headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
                align: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
                width: 140,
                sortable: true,
                type: 'string',
                hide: false,
                filterable: false,
                renderHeader: CommonService.customRenderHeaderColumns,
               
            },

              {
                field: columnFieldsName.pemailTo,
                headerName: intl.formatMessage({ id: "columnname.emailTo.label" }),
                headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
                align: `${pageLabelsConstantsAndMessages.alignment.alignLeft}`,
                width: 350,
                sortable: true,
                filterable: false,
                type: 'string',
                hide: true,
                renderHeader: CommonService.customRenderHeaderColumns
            },
            {
                field: columnFieldsName.pemailCc,
                headerName: intl.formatMessage({ id: "columnname.emailCC.label" }),
                headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
                align: `${pageLabelsConstantsAndMessages.alignment.alignLeft}`,
                width: 350,
                sortable: true,
                filterable: false,
                type: 'string',
                hide: true,
                renderHeader: CommonService.customRenderHeaderColumns
            },
            {
                field: columnFieldsName.pemailBcc,
                headerName: intl.formatMessage({ id: "columnname.entityEmailBcc.label" }),
                headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
                align: `${pageLabelsConstantsAndMessages.alignment.alignLeft}`,
                width: 350,
                sortable: true,
                filterable: false,
                type: 'string',
                hide: true,
                renderHeader: CommonService.customRenderHeaderColumns
            },
            
            {
                field: columnFieldsName.updatedBy,
                headerName: intl.formatMessage({ id: "columnname.updatedby.label" }),
                headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
                align: `${pageLabelsConstantsAndMessages.alignment.alignLeft}`,
                width: 155,
                sortable: true,
                type: 'string',
                hide: false,
                filterable: false,
                renderHeader: CommonService.customRenderHeaderColumns
            },
            {
                field: columnFieldsName.updatedTime,
                headerName: intl.formatMessage({ id: "columnname.updateddate.label" }),
                headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
                align: `${pageLabelsConstantsAndMessages.alignment.alignLeft}`,
                width: 180,
                sortable: true,
                type: 'string',
                hide: false,
                filterable: false,
                renderHeader: CommonService.customRenderHeaderColumns,
                renderCell: (cellParams) => (<span>{cellParams.row.lastUpdatedDtDisp}</span>)
            },
            {
                field: columnFieldsName.createdBy,
                headerName: intl.formatMessage({ id: "columnname.columnnamecreatedby.label" }),
                headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
                align: `${pageLabelsConstantsAndMessages.alignment.alignLeft}`,
                width: 150,
                sortable: true,
                type: 'string',
                hide: true,
                filterable: false,
                renderHeader: CommonService.customRenderHeaderColumns
            },
            {
                field: columnFieldsName.createdTime,
                headerName: intl.formatMessage({ id: "columnname.createddate.label" }),
                headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
                align: `${pageLabelsConstantsAndMessages.alignment.alignLeft}`,
                width: 180,
                sortable: true,
                type: 'string',
                hide: true,
                filterable: false,
                renderHeader: CommonService.customRenderHeaderColumns,
                renderCell: (cellParams) => (<span>{cellParams.row.createdDtDisp}</span>)
            },
        ]

    const [columns, setColumns] = useState([]);
    useEffect(() => {
        setColumns(columnsForEmailMessageConfig)
    }, [selectedLanguage])

    const [tableData, setTableData] = useState([]);

    useEffect(() => {
        if (mode !== 'create') {
            setTableLoadingStatus(true);
            setTableData([]);
            CommonService.GetListApi(apiUrlAndParamBodyConstants.commonApiUrlForAllTheScreen.bpEmailMessageConfigs, paramBody)
                .then((response) => {
                    setTableLoadingStatus(false);
                    setTotalRowCount(response.data.totalElements);
                    setTableData(response.data.content);                  
                })
                .catch(function (error) {
                    setTableLoadingStatus(false);
                    if (error.response !== undefined) {
                        setAlertBoxState({ ...alertBoxState, openAlert: true, message: error.response.data.message, severity: "error" });
                    }
                });
        }
    }, [refreshTable, paramBody, mode])

    const closeConfirmationDialog = (confirmed) => {
        setOpenConfirmationDialog(false);
        if (confirmed) {
            CommonService.deleteByIdApi(`${apiUrlAndParamBodyConstants.commonApiUrlForAllTheScreen.bpEmailMessageConfigs}/${primaryKeyOfSelectedRow}`, {})
                .then((response) => {
                    setAlertBoxState({ ...alertBoxState, openAlert: true, message: <FormattedMessage id="BpEmailCommConfig.snackbar.deletemsg" defaultMessage="Email contact deleted successfully" />, severity: "success" });
                    setRefreshTable(!refreshTable);
                })
                .catch(function (error) {
                    let message = (error.response.data !== undefined || error.response.data !== null) ? error.response.data.message
                        : <FormattedMessage id="BpEmailCommConfig.snackbar.error" defaultMessage="Error occurred while deleting Email contact!" />;
                    setAlertBoxState({ ...alertBoxState, openAlert: true, message: message, severity: "error" });
                });
        }
    }

    const handleDelete = (primaryKey, nameToBeDisplacedOnConfirmationDialog, projectCode) => {
        setPrimaryKeyOfSelectedRow(primaryKey);
        setConfirmationMessage(<FormattedMessage id="common.dialog.areyousure.txt" values={{ nameToBeDisplacedOnConfirmationDialog: ` email contact '${nameToBeDisplacedOnConfirmationDialog}' for project '${projectCode}'` }} defaultMessage={`Are you sure, You want to delete '${nameToBeDisplacedOnConfirmationDialog}'?`} />);
        setOpenConfirmationDialog(true);
    }

    if (columns.length > 0) {

        const validFromDateColumn = columns.find((column) => column.field === columnFieldsName.validFrom);
        const validFromDateColIndex = columns.findIndex((col) => col.field === columnFieldsName.validFrom);

        const validFromDateFilterOperators = getGridDateOperators().map(
            (operator) => ({
                ...operator,
                InputComponent: CustomFilters.DateInputValue,
            }),
        );

        columns[validFromDateColIndex] = {
            ...validFromDateColumn,
            filterOperators: validFromDateFilterOperators,
        };

        const validToDateColumn = columns.find((column) => column.field === columnFieldsName.validTo);
        const validToDateColIndex = columns.findIndex((col) => col.field === columnFieldsName.validTo);

        const validToDateFilterOperators = getGridDateOperators().map(
            (operator) => ({
                ...operator,
                InputComponent: CustomFilters.DateInputValue,
            }),
        );

        columns[validToDateColIndex] = {
            ...validToDateColumn,
            filterOperators: validToDateFilterOperators,
        };
    }

    const filterableColumns = useMemo(() => GetFilterableColumns(columns), [columns])

    const key = "columnField"

    const applyFilter = () => {
        let project = null;
        let validFrom = null;
        let validTo = null;
        selectedFilters.map((columns) => {
            switch (columns.columnField) {
                case 'project':
                    project = columns.value
                    break;
                case 'validFrom':
                    validFrom = columns.value
                    break;
                case 'validTo':
                    validTo = columns.value
                    break;
            }
        })

    setParamBody(prev => ({
        ...prev,
        body: {
            ...prev.body,
            bpCode,
            bpType,
            project,
            validFrom,
            validTo,
             entityCode 
        }
    }));
};
    useEffect(() => {
        setFilterCount([...new Map(selectedFilters.map(item => [item[key], item])).values()].length)
    }, [selectedFilters, tableData])

    return (
        <React.Fragment>
            <CssBaseline />
            <Snackbar
                anchorOrigin={{ vertical, horizontal }}
                open={openAlert}
                onClose={handleCloseAlert}
                key={vertical + horizontal}
                autoHideDuration={6000}
            >
                <Alert onClose={handleCloseAlert} severity={severity}>
                    {message}
                </Alert>
            </Snackbar>
            <Grid container className={classes.rootForRole}>
                <CustomFilterComponent open={openFilterPanel} onClose={handleClose} filterableColumns={filterableColumns}
                    setSelectedFilters={setSelectedFilters} selectedFilters={selectedFilters} applyFilter={applyFilter}
                    defaulSelectedFilters={defaulSelectedFilters} />
                <Paper elevation={3} className={classes.gridHeightAndWidthForEmailMessageConfig}>
                    <div style={{ height: '100%', width: '100%' }}>
                        <DataGridPro
                            className={classes.customTableStyle}
                            sortingMode="server"
                            rows={tableData}
                            columns={columns}
                            pageSize={paramBody.recordsPerPage}
                            loading={tableLoadingStatus}
                            rowCount={totalRowCount}
                            scrollbarSize={30}
                            disableColumnFilter={true}
                            rowsPerPageOptions={[1, 2, 10, 25, 50, 100]}
                            pagination
                            paginationMode="server"
                            disableSelectionOnClick={true}
                            disableColumnMenu={false}
                            disableMultipleColumnsSorting={true}
                            hideFooter={true}
                            localeText={localtext}
                            density="compact"
                            onPageSizeChange={((pageParams) => {
                                setParamBody(prevState => { return { ...prevState, recordsPerPage: pageParams } })
                            })}
                            onPageChange={((pageParams) => {
                                setParamBody(prevState => { return { ...prevState, pageNo: (pageParams) } })
                            })}
                            onSortModelChange={(params) => {
                                let sortModel = params[0];
                                if (sortModel !== undefined) {
                                    setParamBody({ ...paramBody, sortDir: sortModel.sort, sortKey: sortModel.field });
                                }
                            }}
                            components={{
                                Toolbar: () => {
                                    return (
                                        <Grid container
                                            direction="row"
                                            justifyContent="flex-start"
                                            alignItems="center" style={mobileScreen ? { marginBottom: '-0.1%', marginTop: '0%' } : { marginBottom: '-0.3%', marginTop: '-0.5%' }}>
                                            <Grid
                                                item
                                                container
                                                direction="row"
                                                justifyContent="flex-start"
                                                xs={12}
                                                sm={12}
                                                md={6}
                                                lg={6}>
                                                <Grid>
                                                    <Tooltip title={<FormattedMessage id="common.columntoolbar.tooltip" defaultMessage={pageLabelsConstantsAndMessages.label.columns} />} placement='bottom'>
                                                        <GridToolbarColumnsButton className={classes.toobarStyle} variant="outlined" size="medium" />
                                                    </Tooltip>
                                                </Grid>
                                                <Grid>
                                                    <Tooltip title={<FormattedMessage id="common.density.tooltip" defaultMessage={pageLabelsConstantsAndMessages.label.Density} />}
                                                        placement='bottom'>
                                                        <GridToolbarDensitySelector className={classes.toobarStyle} variant="outlined" size="medium" />
                                                    </Tooltip>
                                                </Grid>
                                                <Grid>
                                                    <Tooltip title={<FormattedMessage id="common.toolbarfilterstooltipshow.toolbar.lable" />} placement='bottom'>
                                                        <span>
                                                            <Button className={classes.refreshToobarStyle} variant="outlined" size="medium" onClick={() => setFilterPanel(true)}>
                                                                <Badge color="primary" badgeContent={filterCount}>
                                                                    <FilterList />
                                                                </Badge>
                                                            </Button>
                                                        </span>
                                                    </Tooltip>
                                                </Grid>
                                                <Grid>
                                                    <Tooltip title={<FormattedMessage id="common.button.refresh.tooltip" defaultMessage="Refresh" />} placement='bottom'>
                                                        <span>
                                                            <Button size="small" color="primary" variant="outlined"
                                                                className={classes.refreshToobarStyle}
                                                                onClick={(() => {
                                                                    setRefreshTable(!refreshTable);
                                                                })}>
                                                                <RefreshIcon />
                                                            </Button>
                                                        </span>
                                                    </Tooltip>
                                                </Grid>
                                                <Grid>
                                                    {(emailMessageConfigModuleAccess !== undefined ? emailMessageConfigModuleAccess.createFlag : false) && (mode === 'edit') && (<Tooltip title={<FormattedMessage id="common.button.create.breadcrumb.tooltip" defaultMessage="Refresh" />} placement='bottom'>
                                                        <span>
                                                            <Button size="small" color="primary" variant="outlined"
                                                                className={classes.refreshToobarStyle}
                                                                onClick={(() => {
                                                                    setModeForEmailConfig('create');
                                                                    setOpenEmailMessageConfigDialog(true);
                                                                })}
                                                            >
                                                                <CreateIcon />
                                                            </Button>
                                                        </span>
                                                    </Tooltip>)}
                                                    <EmailMessageConfigDiaglog
                                                        open={OpenEmailMessageConfigDialog}
                                                        onClose={closeEmailMessageConfigDialog}
                                                        title={commonBreadCrumbToBeUsedForDialog}
                                                        mode={modeForEmailConfig}
                                                        emailMessageConfigToBeEdited={emailMessageConfigObjectToBeEditedOrView}
                                                        supplierObjectToBeEditedOrView={supplierObjectToBeEditedOrView}
                                                        customerObjectToBeEditedOrView={customerObjectToBeEditedOrView}
                                                    />
                                                </Grid>
                                            </Grid>
                                            <Grid item xs={12} sm={12} md={6} lg={6}>
                                                <CommonGridPagination />
                                            </Grid>
                                        </Grid>
                                    );
                                },
                            }}
                            sortingOrder={['desc', 'asc']}
                            filterMode="server"
                        />
                    </div>
                </Paper>
                <ConfirmationDialog onClose={closeConfirmationDialog} message={confirmationMessage} open={openConfirmationDialog} />
            </Grid>
        </React.Fragment>
    )
}
export default BpEmailCommConfig;